import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardHeader,
  Avatar,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Grid
} from '@mui/material';
import ImageUpload from '../../components/ImageUpload';

export default function CreateWorker() {
  const navigate = useNavigate();

  const [ime, setIme] = useState('');
  const [prezime, setPrezime] = useState('');
  const [pozicija, setPozicija] = useState('');
  const [mail, setMail] = useState('');
  const [telefon, setTelefon] = useState('');
  const [tipZaposlenja, setTipZaposlenja] = useState('');
  const [aktivan, setAktivan] = useState(false);
  const [odjel, setOdjel] = useState('');
  const [napomena, setNapomena] = useState('');

  const postData = () => {
    fetch('https://smartlight.bhtelecom.ba:3000/api/workers', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        firstName: ime,
        lastName: prezime,
        position: pozicija,
        email: mail,
        phoneNumber: telefon,
        employmentType: tipZaposlenja,
        isActive: aktivan,
        department: odjel,
        notes: napomena
      })
    }).then(() => {
      navigate('/dashboard/WorkersListAll');
    });
  };

  return (
    <div style={{
      backgroundColor: '#0b1446',
      minHeight: '100vh',
      width: '100%',
      padding: '20px'
    }}>
      <Grid container justifyContent="center">
        <Card sx={{ maxWidth: 800, width: '100%', backgroundColor: '#1a237e', color: '#ffffff', borderRadius: 2, boxShadow: 3 }}>
          <CardHeader
            avatar={<Avatar sx={{ width: 60, height: 60 }}>U</Avatar>}
            title={<Typography variant="h6">Novi radnik</Typography>}
          />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Ime"
                  value={ime}
                  onChange={(e) => setIme(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Prezime"
                  value={prezime}
                  onChange={(e) => setPrezime(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Pozicija"
                  value={pozicija}
                  onChange={(e) => setPozicija(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Email"
                  value={mail}
                  onChange={(e) => setMail(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Telefon"
                  value={telefon}
                  onChange={(e) => setTelefon(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  label="Tip zaposlenja"
                  value={tipZaposlenja}
                  onChange={(e) => setTipZaposlenja(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <FormControlLabel
                  control={<Checkbox checked={aktivan} onChange={() => setAktivan(!aktivan)} sx={{ color: '#ffffff' }} />}
                  label="Aktivan"
                />
                <TextField
                  label="Odjel"
                  value={odjel}
                  onChange={(e) => setOdjel(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <TextField
                  label="Napomena"
                  value={napomena}
                  onChange={(e) => setNapomena(e.target.value)}
                  fullWidth
                  margin="normal"
                  variant="outlined"
                  multiline
                  rows={4}
                  InputLabelProps={{ style: { color: '#ffffff' } }}
                  InputProps={{ style: { color: '#ffffff' } }}
                />
                <ImageUpload />
              </Grid>
            </Grid>
            <Button
              variant="contained"
              sx={{ mt: 3, backgroundColor: '#3949ab' }}
              onClick={postData}
            >
              Spasi
            </Button>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
